<message-display
  [heading]="'404 Not Found'"
  [subHeading]="'Sorry this is not what you were looking for'"
  [link]="'/scopes'"
  [linkName]="'My Scopes'"></message-display>
